

/**
 * PageHeader Component - Reusable header for all pages
 * 
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {React.ReactNode} props.statusIndicator - Status indicator component
 * @param {React.ReactNode} props.actions - Additional action components
 * @param {string} props.className - Additional CSS classes
 */
function PageHeader({ 
  title, 
  statusIndicator, 
  actions, 
  className = 'row mb-3', 
}) {
  return (
    <header className={className}>
      <div className="col d-flex align-items-center justify-content-between">
        <h2 className="mb-0 fw-bold">{title}</h2>
        <div className="d-flex align-items-center gap-3">
          {statusIndicator}
          {actions}
        </div>
      </div>
    </header>
  )
}

export default PageHeader
